module.exports = __webpack_public_path__ + "static/media/biglow-woodcraft6.2f27c49e.jpg";